module.exports = __webpack_public_path__ + "img/amadeus.837a4571.png";